"use client";

import { ThemeSwitcher, type ThemeSwitcherProps } from "@/components/ui/ThemeSwitcher";

export function ModeToggle(props: ThemeSwitcherProps) {
  return <ThemeSwitcher {...props} />;
}

export { ThemeSwitcher };

